export const getPxByRem = (rem: number, screenWidth: number = 375) => {
	if (/(iPhone\sOS)\s([\d_]+)/.test(navigator.userAgent)) {
		return ((document.documentElement.clientWidth * 16) / screenWidth) * rem;
	}
	return ((window.innerWidth * 16) / screenWidth) * rem;
};
